import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ContractApiService} from "../../api/contract-api.service";
import {ContractDocumentDto, ContractsRuntimeInsuranceDto, ContractStatusEnum} from "../../types/contracts.types";
import {ActivatedRoute} from "@angular/router";
import {MessageHelper} from "../../../../core/helper/message-helper";
import {AppMessageService} from "../../../../core/service/app-message.service";


@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['contract.component.scss']
})
export class ContractComponent extends CoreComponent implements OnInit {

  @Input() contractId!: number;
  contract: ContractsRuntimeInsuranceDto | undefined;
  navigationSource?: string | undefined | null;

  showDocumentVisible: boolean = false;
  showDocumentId: number | undefined

  constructor(
    protected contractApiService: ContractApiService,
    protected messageService: AppMessageService,
    private route: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.route.paramMap.subscribe(params => {

      let passedId = params.get('id');

      if (passedId) {
        this.contractId = passedId as unknown as number;
      }

      this.navigationSource = params.get('source');
    });

    this.refreshComponent();
  }

  refreshComponent() {

    this.contractApiService.getContract(this.contractId).subscribe(value => {
      this.contract = value;
    },error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    });

    this.initialized = true;
  }

  downloadDocument(contractDocument: ContractDocumentDto) {

    this.showDocumentId = contractDocument.id;
    this.showDocumentVisible = true;
  }

  handleWindowOpened(event: boolean) {
    this.showDocumentVisible = false;
  }


  protected readonly ContractStatusEnum = ContractStatusEnum;
}
